<template>
  <div class="pay-step text-center" style="padding-bottom: 40px;">
    <!--        <div class="upload-tips text-info">导入说明：请先下载本项目-->
    <!--            <el-button class="upload_link" @click="downloadExcel" type="text">批量确认成果</el-button>-->
    <!--                                           文件，在文件中录入成果数据再进行导入.-->
    <!--        </div>-->
    <div class="tips">
      <div class="hd">请先下载批量发布项目需求模板</div>
      <div class="bd">在文件中录入项目数据后再进行导入</div>
      <div class="ft" @click="downloadExcel">
        <img src="../../assets/img/icon-excel.png" alt />
        批量发布项目需求模板.xlsx
        <el-button class="upload_link" type="text">下载</el-button>
      </div>
    </div>
    <el-upload
      class="upload-demo__huge"
      :action="actionUrl"
      :headers="headers"
      drag
      name="project_excel"
      :before-upload="beforeUpload"
      :on-success="uploadSuccess"
      :limit="1"
      accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv"
    >
      <i class="iconfont icon-shangchuanwenjian"></i>
      <div class="el-upload__text">
        点击此处上传录入完成的文件
        <div class="btn-wraper">
          <el-button type="primary">上传文件</el-button>
        </div>
      </div>
    </el-upload>
  </div>
</template>

<script>
import router from '@/router'

export default {
    name: 'BStep1',
    inject: ['back', 'goPage', 'tel'],
    data () {
        return {
            num: 0,
            actionUrl: process.env.VUE_APP_BASE + '/api/user/project/uploadprefork',
            userInfo: {},
            projects: [],
            headers: {},
            timer: null,
            info: {}
        }
    },
    mounted () {
        this.headers = { token: localStorage.getItem('token') }
    },
    methods: {
        downloadExcel () {
            this.download('https://jinsuizhiguan.oss-cn-beijing.aliyuncs.com/templet/%E6%89%B9%E9%87%8F%E5%8F%91%E5%B8%83%E9%A1%B9%E7%9B%AE%E9%9C%80%E6%B1%82%E6%A8%A1%E6%9D%BF.xlsx')
        },
        download (url, fileName = '') {
            let eleLink = document.createElement('a')
            eleLink.download = fileName
            eleLink.style.display = 'none'
            eleLink.href = url
            document.body.appendChild(eleLink)
            eleLink.click()
            document.body.removeChild(eleLink)
        },
        uploadSuccess (res) {
            if (res.code === 0) {
                router.replace(`/index/project/batch/step2?path=${res.data.fullpath}`)
            } else {
                this.$message.error(res.message)
            }
        },
        beforeUpload () {
            // console.log(1)
        }
    }
}
</script>

<style scoped lang="scss">
@import "../../assets/style/sub.scss";

.pay-step {
  .upload-tips {
    margin: 0 0 20px;
  }
}

.tips {
  .hd {
    font-size: 18px;
    margin-top: 30px;
    font-weight: bold;
  }
  .bd {
    font-size: 16px;
    margin-top: 20px;
    color: #999;
  }
  .ft {
    font-size: 16px;
    cursor: pointer;
    margin: 40px 0;
    img {
      height: 16px;
      margin-right: 5px;
      margin-bottom: 1px;
      vertical-align: middle;
    }
    button {
      margin-left: 15px;
      font-size: 16px;
    }
  }
}

.features {
  display: flex;
  width: 740px;
  margin: 35px auto;

  .feature-box {
    flex: 1;
    text-align: center;

    .feature-box__icon {
      .svg-icon {
        font-size: 36px;
      }
    }

    .feature-box__desc {
      margin-top: 13px;
      line-height: 1.5;
    }
  }
}
</style>
